/* eslint-disable prefer-promise-reject-errors */
import objectUtils from '../utils/object-utils'

const mockUserInfo = {
  id: null,
  username: null,
  display_name: null,
  avatar_url: null
}

const mockAuth = {
  auth_token: null,
  expires_at: null
}

export default class MockAuthenticator {
  constructor (options) {
    this.debug = objectUtils.get(options, 'debug', false)
    this.ttl = (options.ttl && !isNaN(options.ttl)) ? Number(options.ttl) : 0
    this.state = {
      user_info: Object.assign({}, mockUserInfo),
      auth: Object.assign({}, mockAuth)
    }
  }

  authenticateUser (creds = {}) {
    return new Promise((resolve, reject) => {
      if (!creds.username) return reject({})

      // Build mock state
      this.buildUserState(creds.username)

      // Generate token
      const token = creds.username
      this.state.auth.auth_token = token
      let expiresAt = null
      if (this.ttl === 0) expiresAt = Date.now()
      if (this.ttl > 0) expiresAt = Date.now() + this.ttl
      this.state.auth.expires_at = expiresAt

      // Return auth info
      return resolve({ token, expires_at: expiresAt })
    })
  }

  fetchUserInfo (options = {}) {
    const tokenData = options.parsed_token

    if (!tokenData) return Promise.reject({})

    // Rebuild mock user state
    this.buildUserState(tokenData)

    return new Promise((resolve) => {
      return resolve({ ...this.state.user_info })
    })
  }

  buildUserState (tokenData) {
    this.state.user_info.id = tokenData
    this.state.user_info.username = tokenData
    this.state.user_info.display_name = tokenData
    this.state.user_info.avatar_url = generateAvatarURL(tokenData)
    this.state.user_info.roles = [tokenData]
  }

  expireUser (token) {
    const activeToken = token || this.state.auth.auth_token
    if (!activeToken) return Promise.reject({})
    return new Promise((resolve) => {
      this.resetState()
      return resolve({})
    })
  }

  resetState () {
    this.state = {
      user_info: Object.assign({}, mockUserInfo),
      auth: Object.assign({}, mockAuth)
    }
  }
}

function generateAvatarURL (username = '') {
  switch (username) {
    case 'drip': return 'https://cdn.shopify.com/s/files/1/0325/8141/9141/collections/Preview-12-10-19_Family_Shot_600x.jpg?v=1581631909'
    default: return 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTenyQCcge4mKO5_BdFvT9gwC80tM1NTFv7kHCYWmUxF-D6-Bs8'
  }
}
